import { ELeadOutcome } from '../services/responses/lead.response';

/// Aviso depois do desfecho: "Cadastro atualizado" não dizia se o lead foi ganho, perdido ou reaberto.
export const OUTCOME_SAVED: Record<ELeadOutcome, string> = {
    [ELeadOutcome.Open]: 'desfecho.reaberto',
    [ELeadOutcome.Won]: 'desfecho.marcadoGanho',
    [ELeadOutcome.Lost]: 'desfecho.marcadoPerdido',
};
